import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { NLParsedFilters } from '../../models/university.models';

export interface SearchState {
  results: any[];
  searchTerm: string;
  appliedFilters: any;
  currentPage: number;
  totalCount: number;
  totalPages: number;
  scrollPosition: number;
  search: string;
  filters: any; // Filter options (dropdowns)
  /** Si los `results` vienen de una búsqueda por lenguaje natural. Se persiste
   *  para que al volver del detalle la página vuelva en modo NL (chips, y una
   *  paginación que re-consulta el endpoint NL y no el de filtros). */
  nlSearchActive: boolean;
  nlParsedFilters: NLParsedFilters | null;
  /** Término que interpretó el back en la última búsqueda NL. */
  nlDegreeName: string;
}

const INITIAL_STATE: SearchState = {
  results: [],
  searchTerm: '',
  appliedFilters: {},
  currentPage: 1,
  totalCount: 0,
  totalPages: 1,
  scrollPosition: 0,
  search: '',
  filters: null,
  nlSearchActive: false,
  nlParsedFilters: null,
  nlDegreeName: ''
};

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private searchStateSubject = new BehaviorSubject<SearchState>(INITIAL_STATE);

  public searchState$: Observable<SearchState> = this.searchStateSubject.asObservable();

  constructor() { }

  setSearchResults(results: any[], searchTerm: string): void {
    const current = this.searchStateSubject.value;
    this.searchStateSubject.next({
      ...current,
      results,
      searchTerm
    });
  }

  saveSearchState(state: Partial<SearchState>): void {
    const current = this.searchStateSubject.value;
    this.searchStateSubject.next({
      ...current,
      ...state
    });
  }

  getSearchState(): SearchState {
    return this.searchStateSubject.value;
  }

  hasPersistedState(): boolean {
    const state = this.searchStateSubject.value;
    return state.results.length > 0 || Object.keys(state.appliedFilters).length > 0;
  }

  clearSearch(): void {
    this.searchStateSubject.next(INITIAL_STATE);
  }
}
